const decodeToken = (token) => {
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/').padEnd(Math.ceil(base64Url.length / 4) * 4, '=');
        const jsonPayload = decodeURIComponent(
            atob(base64).split('').map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')
        );
        return JSON.parse(jsonPayload);
    } catch {
        return null;
    }
};

export const getDecodedToken = () => {
    const token = getSessionCookie();
    if (!token) return null;
    return decodeToken(token);
};

export const getUserRole = () => {
    const decoded = getDecodedToken();
    return decoded?.role || null;
};

export const isPsicologo = () => {
    const decoded = getDecodedToken();
    return decoded?.id_psicologo != null || decoded?.role === 'ROLE_ADMIN';
};

export const getIdUsuario = () => {
    const decoded = getDecodedToken();
    return decoded?.id_usuario || null;
};

export const isVisualizador = () => getUserRole() === 'ROLE_VISUALIZADOR';
export const isAdmin = () => getUserRole() === 'ROLE_ADMIN';

export const setSessionCookie = (token) => {
    // Cria um cookie sem data de expiração (morre ao fechar o navegador)
    document.cookie = `sigapsi_token=${token}; path=/`;
};

export const getSessionCookie = () => {
    const name = "sigapsi_token=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return null;
};

export const removeSessionCookie = () => {
    document.cookie = "sigapsi_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
};
